import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import lazy from "./LazyComponent";
import MainLayout from "@/layout/Main";
const ChannelLayout = () => import("@/layout/Channel");
const AIDraw = () => import("@/views/AIDraw");
const AIEdit = () => import("@/views/AIEdit");
// const DetailEnhanceIntrodPage = () => import("@/views/DetailEnhanceIntrodPage");
const CoCreateHomePage = () => import("@/views/CoCreateHomePage");
const InspirationHomePage = () => import("@/views/InspirationHomePage");
const ChannelContent = () => import("@/views/Channel");
const ThreadLayout = () => import("@/views/Thread");
const WorkManagePage = () => import("@/views/WorkManage");

const SharePage = () => import("@/views/SharePage");
const DetailEnhanceIntrodPageV3 = () => import("@/views/DetailEnhanceIntrodPageV3");
const VipRechargeModal = () => import("@/componentsNew/VipRechargeModal");
const LykPay = () => import("@/layout/LykPay");
const AIEditV3 = () => import("@/views/AIEditV3");
const WorkManageV3 = () => import("@/views/WorkManageV3");
const Index = () => import("@/views/Index");
const Home = () => import("@/views/Home");
const Toolkit = () => import("@/views/Toolkit");
const AIRender = () => import("@/views/AIRender");
const PlaneColoring = () => import("@/views/PlaneColoring");
// AI改图
const AIChangePic = () => import("@/views/AIChangePic");
const AIPlanSpeculation = () => import("@/views/AIPlanSpeculation");

const routes = () => {
  return (
    <Routes>
      <Route path="lykPay" element={lazy(LykPay)} >
        <Route path="vipRecharge" element={lazy(VipRechargeModal)} />
      </Route>
      <Route path="sharePage/:code/:invite_code" index element={lazy(SharePage)} />
      <Route index element={<Navigate to="pro" />} />
{/* 
      <Route path="main" element={<MainLayout />}>
        <Route index element={<Navigate to={'AIDraw'} replace={true} />} />
        <Route path="channel/" element={lazy(ChannelLayout)}>
          <Route
            path=":serverId/:channelId"
            element={lazy(ChannelContent)}
          ></Route>
          <Route
            path=":serverId/:channelId/:threadId"
            element={lazy(ThreadLayout)}
          ></Route>
        </Route>
        <Route path="AIDraw" element={lazy(AIDraw)}></Route>
        <Route path="AIEdit" element={lazy(AIEdit)}></Route>
        <Route path="AIEditDetailEnhance" element={lazy(DetailEnhanceIntrodPage)}></Route>
        <Route path="coCreateHomePage" element={lazy(CoCreateHomePage)}></Route>
        <Route path="inspirationHomePage" element={lazy(InspirationHomePage)}></Route>
        <Route path="workManagePage" element={lazy(WorkManagePage)}></Route>
      </Route> */}
      
      <Route path="pro" element={<MainLayout />}>
        <Route index element={<Navigate to={'Home'} replace={true} />} />
        <Route path="Home" element={lazy(Home)}></Route>
        <Route path="Index" element={lazy(Index)}></Route>
        <Route path="AIEditDetailEnhance" element={lazy(DetailEnhanceIntrodPageV3)}></Route>
        <Route path="workManagePage" element={lazy(WorkManageV3)}></Route>
        <Route path="Canvas" element={lazy(AIEditV3)}></Route>
        <Route path="Toolkit" element={lazy(Toolkit)}></Route>
        <Route path="AIRender" element={lazy(AIRender)}></Route>
        <Route path="PlaneColoring" element={lazy(PlaneColoring)}></Route>
        <Route path="AIRender" element={lazy(AIRender)}></Route>
        <Route path="ChangePic" element={lazy(AIChangePic)}></Route>
        <Route path="AIPlanSpeculation" element={lazy(AIPlanSpeculation)}></Route>
      </Route>
      
      <Route path="*" element={<Navigate to="/#/pro/Home" replace />} />
    </Routes>
  );
};

export default routes;
